// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"e8e1443f","455":"8238f597","464":"167172cd","938":"c4638bf4","977":"d4b2cb50"}[chunkId] + ".chunk.js";
};